<template>
  <div class="ui-page-msg" :class="bgCss">
    <div class="icon">
      <i :class="icon" :style="iconSizeComputed"></i>
    </div>
    <div class="text" v-html="text"></div>
    <div class="control" v-if="action">
      <ui-button type="submit" design="lg primary mw-200" @click="action">
        {{ btnText }} <i :class="btnIcon"></i
      ></ui-button>
    </div>
  </div>
</template>

<script>
import { uiButton } from "@/components/ui/buttons";
export default {
  components: { uiButton },
  name: "ui-page-msg",
  props: {
    icon: {
      type: String,
      required: false,
    },
    iconSize: {
      type: String,
      required: false,
      default: "100px",
    },
    text: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
    },
    bg: {
      type: Boolean,
      required: false,
      default: false,
    },
    btnText: {
      type: String,
      required: false,
    },
    btnIcon: {
      type: String,
      required: false,
    },
  },
  computed: {
    iconSizeComputed() {
      return `font-size: ${this.iconSize}px`;
    },
    bgCss() {
      return this.bg ? "bg" : "";
    },
  },
};
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>